<template>
  <div ref="appTooltipRef" class="app-tooltip">
    <div ref="tooltipTarget" class="app-tooltip__target">
      <slot></slot>
    </div>
    <div ref="tooltipContent" class="app-tooltip__content">
      <slot name="tooltip"> </slot>
    </div>
  </div>
</template>

<script setup>
import { createPopper } from '@popperjs/core'
import { onMounted, ref } from 'vue'
import { onClickOutside } from '@vueuse/core'

const tooltipTarget = ref(null)
const tooltipContent = ref(null)

onMounted(() => {
  const popper = createPopper(tooltipTarget.value, tooltipContent.value, {
    placement: 'top',
    strategy: 'fixed',
  })

  onClickOutside(tooltipContent, () => {
    if (!tooltipContent.value.hasAttribute('data-show')) return
    hide()
  })

  function show() {
    tooltipContent.value.setAttribute('data-show', '')
    popper.update()
  }

  function hide(event) {
    // relatedTarget is null when leaving the window, and the onClickOutside
    // handler calls hide() without an event; both should hide the tooltip.
    const hoveredElement = event?.relatedTarget
    const isPopper = hoveredElement?.dataset['popperPlacement']

    if (!isPopper) {
      tooltipContent.value.removeAttribute('data-show')
    }
  }

  const showEvents = ['mouseover']
  showEvents.forEach((event) => {
    tooltipTarget.value.addEventListener(event, show)
  })

  const hideEvents = ['mouseleave']

  hideEvents.forEach((event) => {
    tooltipTarget.value.addEventListener(event, hide)
    tooltipContent.value.addEventListener(event, hide)
  })
})
</script>
